<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <dev-list-form :disabled="disableSubmit" :disabledCols="disabledCols" @ok="submitCallback" ref="realForm"></dev-list-form>
  </j-modal>
</template>

<script>

  import DevListForm from './DevListForm'
  export default {
    name: 'DevListModal',
    components: {
      DevListForm
    },
    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        disabledCols: []
      }
    },
    methods: {
      add () {
        this.disabledCols = [];
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.disabledCols = [];
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      retire (record) {
        this.disabledCols = ['devTag', 'devName', 'devProcessId', 'parentId', 'serviceStatus', 'importance'];
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm(this.title === '换新' ? 'retire' : '');
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>